<div
	class="title-header flex justify-between pl-2.5 md:pr-5 pr-4 items-center py-4 border-b border-b-neutral-color-i"
>
	<span class="text-title !text-2xl md:!text-4xl text-complementary-color-a font-bold font-lato">
		{{ title }}
	</span>
	<button
		class="bg-primary-color text-white button-new items-center hover:bg-complementary-color-a"
		(click)="action()"
		[matTooltip]="hoverButton"
	>
		<img src="../../../../assets/icon/add.svg" alt="plus" class="mr-2 w-4 h-4" />
		<span class="font-lato font-extrabold text-lg">
			{{ textButton }}
		</span>
	</button>
</div>
